import cannedFiles_routes from './CannedFiles/cannedFiles.route';
import cannedResponses_routes from './CannedResponses/cannedResponses.route';
import channels_routes from './Channels/Channels.routes';
import closingNotes_routes from './ClosingNotes/closing-notes.route';
import conversationsSettingsRoutes from './Conversations/conversations-settings';
import custom_attrbutes_routes from './CustomAttributes/custom.routes';
import notifications_routes from './Notifications/notifications.routes';
import roles_routes from './Roles/roles.routes';
import tags_routes from './Tags/tags.routes';
import teams_routes from './Teams/teams.routes';
import users_routes from './Users/users.routes';

const settings_routes = [
  {
    path: '/settings',
    name: 'settings',
    meta: {
      header: {
        title: 'GLOBAL.NAVS.SETTINGS',
        icon: 'bvi-setting',
      },
      sidebar: [
        {
          icon: 'bvi-bell',
          title: 'global.sidebar.notifications_trans',
          route: { name: 's-notifications' },
        },
        {
          icon: 'bvi-message-text',
          title: 'global.sidebar.conversations_setting_trans',
          route: { name: 'settings.conversations-setting' },
          visible: true,
        },
        {
          icon: 'bvi-user-multiple',
          title: 'global.sidebar.teams_trans',
          route: { name: 's-teams' },
          permissions: 'read-teams',
        },
        {
          icon: 'bvi-user-group',
          title: 'global.sidebar.users_trans',
          route: { name: 's-users' },
          permissions: 'read-users',
        },
        {
          icon: 'bvi-tag',
          title: 'global.sidebar.tags_trans',
          route: { name: 's-tags' },
          permissions: 'read-tags',
        },
        {
          icon: 'bvi-channels',
          title: 'global.sidebar.channels_trans',
          route: { name: 's-channels' },
          permissions: 'read-channels',
        },
        {
          icon: 'bvi-folder-cloud',
          title: 'global.sidebar.canned_trans',
          route: { name: 's-canned-files' },
          permissions: 'read-canned-files',
        },
        {
          icon: 'bvi-folder-messages',
          title: 'global.sidebar.response_trans',
          route: { name: 's-canned-responses' },
          permissions: 'read-canned-responses',
        },
        {
          icon: 'bvi-key',
          title: 'global.sidebar.roles_trans',
          route: { name: 's-roles' },
          permissions: 'read-roles-&-permissions',
        },
        {
          icon: 'bvi-notebook',
          title: 'global.sidebar.closing_trans',
          route: { name: 's-closing-notes' },
          permissions: 'read-closing-notes',
        },
        {
          icon: 'bvi-code-circle',
          title: 'global.sidebar.custom_attributes_trans',
          route: { name: 's-custom-attributes' },
          permissions: 'read-custom-attributes',
        },
      ],
    },
    children: [
      ...notifications_routes,
      ...users_routes,
      ...teams_routes,
      ...tags_routes,
      ...roles_routes,
      ...channels_routes,
      ...closingNotes_routes,
      ...cannedResponses_routes,
      ...cannedFiles_routes,
      // ...integrations_routes,
      ...custom_attrbutes_routes,
      ...conversationsSettingsRoutes,
    ],
  },
];

export default settings_routes;
